import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, take } from 'rxjs/operators';
import { AssignRegisterLoanAction, CreateLoanAction, DeleteLoanAction, EditLoanAction, FinishLoanAction, GrantLoanAction, LoanActionTypes, RenewLoanAction, ReturnLoanAction, ValidateLoanAction, ValidateRenewLoanAction, ViewLoanAction } from '../actions/loan-actions';
import { AppStore, getAppSelection } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { LoanService } from '../../services/loan.service';
import { UdeuService } from '../../services/udeu.service';
import { Router } from '@angular/router';
import { UDEU_STRUCTURAL_FOLDER_NAME_PROP } from '../../model/contants/deusto';

@Injectable()
export class LoanEffects {
  constructor(
    private store: Store<AppStore>,
    private actions$: Actions,
    private loanService: LoanService,
    private udeuService: UdeuService,
    private router: Router
  ) { }


  createLoan$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<CreateLoanAction>(LoanActionTypes.CreateLoan),
        map((_action) => {
          this.loanService.openCreateLoanDialogComponent();
        })
      ),
    { dispatch: false }
  );

  viewLoan$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<ViewLoanAction>(LoanActionTypes.ViewLoan),
        map((action) => {
          this.openLoanDialogComponent(action, LoanActionTypes.ViewLoan);
        })
      ),
    { dispatch: false }
  );

  validateLoan$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<ValidateLoanAction>(LoanActionTypes.ValidateLoan),
        map((action) => {
          this.openLoanDialogComponent(action, LoanActionTypes.ValidateLoan);
        })
      ),
    { dispatch: false }
  );

  editLoan$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<EditLoanAction>(LoanActionTypes.EditLoan),
        map((action) => {
          this.openLoanDialogComponent(action, LoanActionTypes.EditLoan);
        })
      ),
    { dispatch: false }
  );

  assignRegisterLoan$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<AssignRegisterLoanAction>(LoanActionTypes.AssignRegisterLoan),
        map((action: any) => {
          const route = '/viewer/records';
          if (action && action.payload && action.payload.length > 0) {
            const state =  { loanUUID: action };
            this.router.navigate([route], { state });
          } else {
            this.store
              .select(getAppSelection)
              .pipe(take(1))
              .subscribe((selection) => {
                if (selection && selection.count > 0) {
                  const node = selection.nodes[0].entry;
                  const loan = { UUID: node.id, name: node.properties[UDEU_STRUCTURAL_FOLDER_NAME_PROP] }
                  const state =  { loan };
                  this.router.navigate([route], { state });
                }
              });
          }
        })
      ),
    { dispatch: false }
  );

  grantLoan$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<GrantLoanAction>(LoanActionTypes.GrantLoan),
        map((action) => {
          this.openLoanDialogComponent(action, LoanActionTypes.GrantLoan);
        })
      ),
    { dispatch: false }
  );

  returnLoan$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<ReturnLoanAction>(LoanActionTypes.ReturnLoan),
        map((action) => {
          this.openLoanDialogComponent(action, LoanActionTypes.ReturnLoan);
        })
      ),
    { dispatch: false }
  );

  validateRenewLoan$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<ValidateRenewLoanAction>(LoanActionTypes.ValidateRenewLoan),
        map((action) => {
          this.openLoanDialogComponent(action, LoanActionTypes.ValidateRenewLoan);
        })
      ),
    { dispatch: false }
  );
  
  renewLoan$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<RenewLoanAction>(LoanActionTypes.RenewLoan),
        map((action: any) => {
          if (action && action.payload && action.payload.length > 0) {
            this.loanService.openLoanRenewDialogComponent(action);
          } else {
            this.store
              .select(getAppSelection)
              .pipe(take(1))
              .subscribe((selection) => {
                if (selection && selection.count > 0) {
                  const UUID = selection.nodes.map((nodeEntry) => nodeEntry.entry.id)[0];
                  this.loanService.openLoanRenewDialogComponent(UUID);
                }
              });
          }
        })
      ),
    { dispatch: false }
  );

  deleteLoan$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<DeleteLoanAction>(LoanActionTypes.DeleteLoan),
        map((action) => {
          if (action && action.payload && action.payload.length > 0) {
            this.udeuService.deleteNode(action.payload);
          } else {
            this.store
              .select(getAppSelection)
              .pipe(take(1))
              .subscribe((selection) => {
                if (selection && selection.count > 0) {
                  this.udeuService.deleteNode(selection.nodes);
                }
              });
          }
        })
      ),
    { dispatch: false }
  );
    
  finishLoan$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<FinishLoanAction>(LoanActionTypes.FinishLoan),
        map((action) => {
          this.openLoanDialogComponent(action, LoanActionTypes.FinishLoan);
        })
      ),
    { dispatch: false }
  );

  private openLoanDialogComponent(action: any, loanActionType: LoanActionTypes) {
    if (action && action.payload && action.payload.length > 0) {
      this.loanService.openLoanDialogComponent(action, loanActionType);
    } else {
      this.store
        .select(getAppSelection)
        .pipe(take(1))
        .subscribe((selection) => {
          if (selection && selection.count > 0) {
            const UUID = selection.nodes.map((nodeEntry) => nodeEntry.entry.id)[0];
            this.loanService.openLoanDialogComponent(UUID, loanActionType);
          }
        });
    }
  }

}
